import React, { FC } from "react";

import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { Link, Stack, Typography } from "@mui/material";

/**
 * Data collection Opt out box
 *
 * We use these services to better understand our customers, and they
 * need a way to opt out of such identification services
 */
const DataCollectionOptout: FC = () => {
  return (
    <Stack
      sx={{
        border: `solid 1px ${Colors.BorderDefault}`,
        borderRadius: "8px",
        width: "100%",
        maxWidth: "750px",
        marginX: "auto",
        padding: "20px",
        marginY: "24px",
        gap: "10px",
      }}
    >
      <Typography variant="h5">Sub-processor opt-outs</Typography>

      <Typography variant="body1">
        Opt-out of individual sub-processor data collection or retention:
        <ul>
          <li>
            <Link
              href="https://app.retention.com/optout/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Retention.com Database Opt-Out (RB2B)
            </Link>
          </li>
        </ul>
      </Typography>
    </Stack>
  );
};

export default DataCollectionOptout;
